import {post} from './api-calls';
import {IEngagementPointDto} from '../dtos/IEngagementPointDto';

export const addEngagementPointDatabase = (
  data: IEngagementPointDto,
): Promise<IEngagementPointDto> => {
  return post(`/engagementPoint`, data);
};
